import { translate } from 'react-translate'

import DeviceName from './device-name'

export default translate('DeviceType')(DeviceName)
